@if (isLoading===true) {
  <div class="spinner-container">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
    </mat-progress-spinner>
  </div>
}

<app-dynamic></app-dynamic>
